import { searchRouteProps } from 'src/navigation/routeProps'
import { createFlyoutReducer } from 'src/redux/genericReducers'
import VirtualCardsFullPaginatedDataReducer, {
  Actions as VirtualCardsFullPaginatedDataActions,
  initialState as initialVirtualCardsFullPaginatedDataState,
  VirtualCardsFullPaginatedDataState,
} from 'src/redux/virtualCardsFullPaginatedData.reducer'

export interface SearchState {
  virtualCardsFullPaginatedData: VirtualCardsFullPaginatedDataState
}

export const initialState: SearchState = {
  virtualCardsFullPaginatedData: initialVirtualCardsFullPaginatedDataState,
}

export type Actions = VirtualCardsFullPaginatedDataActions

const CoreSearchReducer = (
  state = initialState,
  action: Actions,
): SearchState => ({
  virtualCardsFullPaginatedData: VirtualCardsFullPaginatedDataReducer(
    state.virtualCardsFullPaginatedData,
    action as VirtualCardsFullPaginatedDataActions,
  ),
})

const SearchReducer = createFlyoutReducer(
  searchRouteProps,
  initialState,
  CoreSearchReducer,
)

export default SearchReducer
